import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { IMenuAjudaState } from './types'
import { ReactNode } from 'react'

export interface MenuAjudaProp {
  titulo: string
  nomeTrackEvent: string
  children: ReactNode | string
}

const initialState: IMenuAjudaState = {
  open: false,
  titulo: '',
  nomeTrackEvent: '',
  children: ''
}

const menuAjudaSlice = createSlice({
  name: 'menuAjuda',
  initialState,
  reducers: {
    setMenuAjuda: (state, action: PayloadAction<MenuAjudaProp>) => {
      return {
        ...state,
        open: true,
        ...action.payload
      }
    },
    setClose: () => initialState
  }
})

export const { setMenuAjuda, setClose } = menuAjudaSlice.actions
export const menuAjudaReducer = menuAjudaSlice.reducer
export const menuAjudaState = (state: RootState) => state.menuAjuda
